import { Alert, Box, Button, Flex, Text } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { FiEdit2 } from 'react-icons/fi';

import { formatCountdown, type CountdownConfig } from './countdown-config';

export interface CountdownBlockProps {
  config: CountdownConfig;
  parseError?: string | null;
  canEdit?: boolean;
  onEdit?: () => void;
}

export function CountdownBlock({
  config,
  parseError,
  canEdit = false,
  onEdit,
}: CountdownBlockProps) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => {
      setNow(new Date());
    }, 30 * 1000);
    return () => {
      window.clearInterval(id);
    };
  }, []);

  const countdown = useMemo(() => formatCountdown(config, now), [config, now]);
  const rightPalette = countdown.completed ? 'green.500' : 'blue.500';

  return (
    <>
      <Flex className="markdown-countdown-node__pill" align="stretch">
        <Box className="markdown-countdown-node__segment">
          <Text fontSize="sm" fontWeight="medium">
            {config.name || 'Unnamed'}
          </Text>
        </Box>
        <Box
          className="markdown-countdown-node__segment markdown-countdown-node__segment--value"
          bg={rightPalette}
        >
          <Text fontSize="sm" fontWeight="semibold" color="white">
            {countdown.primaryText}
          </Text>
        </Box>
        {onEdit ? (
          <Button
            className="markdown-countdown-node__edit"
            type="button"
            size="sm"
            variant="solid"
            colorPalette="gray"
            aria-label="Edit countdown"
            onMouseDown={(event) => {
              event.preventDefault();
            }}
            onClick={onEdit}
            disabled={!canEdit}
          >
            <FiEdit2 />
          </Button>
        ) : null}
      </Flex>

      {parseError ? (
        <Alert.Root status="warning" mt={3} borderRadius="md">
          <Alert.Indicator />
          <Alert.Content>
            <Alert.Title>Invalid countdown config</Alert.Title>
            <Alert.Description>{parseError}</Alert.Description>
          </Alert.Content>
        </Alert.Root>
      ) : null}
    </>
  );
}
